import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DataGridHeader = (props) => {
  const [tagsObj, setTagsObj] = useState([]);
  const [allTagActive, setAllTagActive] = useState(false);

  const generateTagsObj = (tags) => {
    const tagsObjTemp = [];
    if (tags && tags.length !== 0) {
      for (let i = 0; i < tags.length; i++) {
        const tagObj = {
          tag: tags[i],
          isActive: false,
        };
        tagsObjTemp.push(tagObj);
      }
    }

    return tagsObjTemp;
  };

  useEffect(() => {
    setTagsObj(generateTagsObj(props.tags));
  }, [props.tags]);

  const checkActiveTags = (tagsObjTemp) => {
    const { onTagSelected } = props;
    const activeTags = [];
    for (let i = 0; i < tagsObjTemp.length; i++) {
      if (tagsObjTemp[i].isActive) {
        activeTags.push(tagsObj[i].tag);
      }
    }
    onTagSelected(activeTags);
  };

  const tagClickHandler = (tagObj, index) => {
    const tagsObjTemp = [...tagsObj];
    tagsObjTemp[index].isActive = !tagObj.isActive;
    setTagsObj(tagsObjTemp);
    checkActiveTags(tagsObjTemp);
  };

  const allTagClickHandler = (active) => {
    const allTagActiveTemp = !active;
    const tagsObjTemp = [...tagsObj];
    for (let i = 0; i < tagsObjTemp.length; i++) {
      tagsObjTemp[i].isActive = allTagActiveTemp;
    }
    setAllTagActive(allTagActiveTemp);
    setTagsObj(tagsObjTemp);
    checkActiveTags(tagsObjTemp);
  };

  const renderTagsHeader = (props.tags && props.tags.length !== 0) ?
    (
      <div className="header-tag-container">
        <button
          onClick={() => { allTagClickHandler(allTagActive); }}
          className={classNames('btn btn-xs grid-tag', (allTagActive) && 'active')}
        >
          All
        </button>
        {
          tagsObj.map((tagObj, index) => (
            <button
              key={`header-tag${index.toString()}`}
              onClick={() => { tagClickHandler(tagObj, index); }}
              className={classNames('btn btn-xs grid-tag', (tagObj.isActive) && 'active')}
            >
              {tagObj.tag}
            </button>
          ))
        }
      </div>
    ) :
    null;

  const renderHeader = (renderTagsHeader === null) ?
    null :
    (
      <div className="virtual-data-table-haader">
        {renderTagsHeader}
      </div>
    );

  return (
    <div>
      {renderHeader}
    </div>
  );
};

DataGridHeader.propTypes = {
  tags: PropTypes.array,
  onTagSelected: PropTypes.func,
};

DataGridHeader.defaultProps = {
  tags: [],
  onTagSelected: () => {},
};

export default DataGridHeader;



// WEBPACK FOOTER //
// ./src/components/Tables/DataGridHeader.js